import { Maximize2, Minimize2 } from 'lucide-react';
import { useUi } from '../../store/ui';
import { BacklinksPanel } from '../links/BacklinksPanel';
import { PropertiesPanel } from '../types/PropertiesPanel';
import { OutlinePanel } from '../links/OutlinePanel';
import { LocalGraphPanel } from '../links/LocalGraphPanel';
import { AgentPanel } from '../agent/AgentPanel';
import { ProposalsPanel, useProposals } from '../agent/ProposalsPanel';
import { useAgent } from '../../store/agent';
import { ErrorBoundary } from './ErrorBoundary';

export function RightDock() {
  const tab = useUi((s) => s.dockTab);
  const setTab = useUi((s) => s.setDockTab);
  const noteId = useUi((s) => s.panes.find((p) => p.id === s.activePaneId)?.noteId ?? null);
  const pending = useProposals('PENDING').data?.pending ?? 0;
  const approvals = useAgent((s) => s.pendingApprovals.length);
  const running = useAgent((s) => s.status === 'RUNNING');
  const full = useUi((s) => s.dockFull);
  const toggleFull = useUi((s) => s.toggleDockFull);
  return (
    <div className={`dock hairline-l${full ? ' full' : ''}`}>
      <div className="dock-tabs">
        <button className={tab === 'agent' ? 'on' : ''} onClick={() => setTab('agent')}>
          Agent{approvals > 0 ? <span className="tab-badge warn">{approvals}</span> : running ? <span className="light teal" style={{ marginLeft: 5 }} /> : null}
        </button>
        <button className={tab === 'proposals' ? 'on' : ''} onClick={() => setTab('proposals')}>
          Proposals{pending > 0 && <span className="tab-badge">{pending}</span>}
        </button>
        <button className={tab === 'backlinks' ? 'on' : ''} onClick={() => setTab('backlinks')}>Backlinks</button>
        <button className={tab === 'properties' ? 'on' : ''} onClick={() => setTab('properties')}>Properties</button>
        <button className={tab === 'outline' ? 'on' : ''} onClick={() => setTab('outline')}>Outline</button>
        <button className={tab === 'graph' ? 'on' : ''} onClick={() => setTab('graph')}>Graph</button>
        <span className="spacer" />
        <button
          className="icon dock-full-toggle"
          title={full ? 'Back to the side panel (Esc)' : 'Expand across the screen (Ctrl+Shift+Enter)'}
          aria-label={full ? 'Collapse the dock' : 'Expand the dock across the screen'}
          aria-pressed={full}
          onClick={() => toggleFull()}
        >
          {full ? <Minimize2 size={14} /> : <Maximize2 size={14} />}
        </button>
      </div>
      <div className={`dock-body${tab === 'agent' ? ' flush' : ''}`}>
        {tab === 'agent' && <ErrorBoundary what="agent panel"><AgentPanel /></ErrorBoundary>}
        {tab === 'proposals' && <ProposalsPanel />}
        {tab === 'backlinks' && <BacklinksPanel noteId={noteId} />}
        {tab === 'properties' && <PropertiesPanel noteId={noteId} />}
        {tab === 'outline' && <OutlinePanel noteId={noteId} />}
        {tab === 'graph' && <LocalGraphPanel noteId={noteId} />}
      </div>
    </div>
  );
}
